import { useAB } from '@insify/funnel-components';
import { makeProviderWithHook } from '@insify/ui-utils';
import { useState } from 'react';

import { isPromotionComparadise } from '../usePromotion';
import { useConditionsQuery, useHighCareConditions, useParamsQuery, useProspectStatusQuery } from '../useQueries';

import { getSteps } from './getSteps';

export const stepsContext = makeProviderWithHook(
  'steps',
  () => {
    const [isEnteringCompanyDetails, setIsEnteringCompanyDetails] = useState<boolean>(false);
    const [hasRequestedHighCare, setHasRequestedHighCare] = useState<boolean>(false);
    const [hasSubmittedApplication, setHasSubmittedApplication] = useState<boolean>();
    const quoteParamsQuery = useParamsQuery();
    const quoteConditionsQuery = useConditionsQuery();
    const highCareConditions = useHighCareConditions();
    const prospectStatusQuery = useProspectStatusQuery();

    const ab = useAB();
    const isPromoComparadise = isPromotionComparadise();

    const stepsAreLoading = [quoteParamsQuery, quoteConditionsQuery, highCareConditions, prospectStatusQuery].some(
      (query) => (query.isFetching || query.isStale) && !query.isError,
    );

    const steps = getSteps({
      quoteParams: quoteParamsQuery.data,
      quoteConditions: quoteConditionsQuery.data,
      highCareConditions: highCareConditions.data,
      isEnteringCompanyDetails,
      hasRequestedHighCare,
      prospectStatus: prospectStatusQuery.data,
      hasSubmittedApplication,
      showContactStep: ab.experiments.showContactStep === true && !isPromoComparadise,
    });

    return {
      steps,
      stepsAreLoading,
      isEnteringCompanyDetails,
      setIsEnteringCompanyDetails,
      hasRequestedHighCare,
      setHasRequestedHighCare,
      setHasSubmittedApplication,
    };
  },
  undefined,
);
